
import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles( theme => ({
    buffer: {
      paddingLeft: 40
    },
    center: {
        textAlign: "center"
    },
    compoundInput: {
      top: -10
    },
    selectorContainer: {
        borderTop: "1px #ccc solid",
        marginBottom: 20,
        marginTop: 20,
        paddingTop: 20
    },
}))

export default useStyles